function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0215 1.02159C12.5782 0.578252 11.9832 0.333252 11.3648 0.333252H2.99984C1.7165 0.333252 0.666504 1.38325 0.666504 2.66659V21.3333C0.666504 22.6166 1.70484 23.6666 2.98817 23.6666H16.9998C18.2832 23.6666 19.3332 22.6166 19.3332 21.3333V8.30159C19.3332 7.68325 19.0882 7.08825 18.6448 6.65659L13.0215 1.02159ZM13.4998 18.9999H6.49984C5.85817 18.9999 5.33317 18.4749 5.33317 17.8333C5.33317 17.1916 5.85817 16.6666 6.49984 16.6666H13.4998C14.1415 16.6666 14.6665 17.1916 14.6665 17.8333C14.6665 18.4749 14.1415 18.9999 13.4998 18.9999ZM13.4998 14.3333H6.49984C5.85817 14.3333 5.33317 13.8083 5.33317 13.1666C5.33317 12.5249 5.85817 11.9999 6.49984 11.9999H13.4998C14.1415 11.9999 14.6665 12.5249 14.6665 13.1666C14.6665 13.8083 14.1415 14.3333 13.4998 14.3333ZM11.1665 7.33325V2.08325L17.5832 8.49992H12.3332C11.6915 8.49992 11.1665 7.97492 11.1665 7.33325Z",
  fill: "#007AFF"
});

function SvgFiledAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiledAccounts);
export default __webpack_public_path__ + "static/media/filedAccounts.23b6de25.svg";
export { ForwardRef as ReactComponent };